export const MIGRATION_SCREEN_SHOW = 'migration_screen/SHOW'
export const MIGRATION_SCREEN_HIDE = 'migration_screen/HIDE'

export function showMigrationScreen() {
    return {
        type: MIGRATION_SCREEN_SHOW,
    }
}

export function hideMigrationScreen() {
    return {
        type: MIGRATION_SCREEN_HIDE,
    }
}



// WEBPACK FOOTER //
// ./state/actions/migration_screen.js